var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenancyLoaded)?_c('div',{staticClass:"tenancy"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"defaultHeader":_vm.defaultHeader}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }